import { Box, Text, theme } from '@frameio/vapor';
import { IconWarning } from '@frameio/vapor-icons';
import { AppUiThemeStaticDark } from '../contexts/AppUiThemeContext/AppUiThemeStatic';

export const ServerErrorLayout = () => {
  return (
    <AppUiThemeStaticDark>
      <Box
        alignItems="center"
        backgroundColor="panel"
        borderRadius={8}
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
        textAlign="center"
        width="100%"
      >
        <IconWarning
          aria-hidden={true}
          color={theme.colors.icon.interactive.informative}
          size={24}
        />
        <Text>Something went wrong</Text>
      </Box>
    </AppUiThemeStaticDark>
  );
};
